import React from 'react';

import getPopulation from '../../services/population.service';
import getWorldData from '../../services/covid-statistics.service';
import getGeoLocationData from '../../services/geolocation.service';
import getGlobalTimeSeries from '../../services/global-time-series.service';

import {
  RECOVERED, DEATHS, CONFIRMED, DEFAULT_PERIOD, DEFAULT_QUALITY,
} from '../../constants';

import extendFlagURL from '../../utils/extendFlagURL';
import countriesExtendCovidData from '../../utils/countriesExtendCovidData';
import markersExtendCovidData from '../../utils/markersExtendCovidData';
import createGeoJson from '../../utils/createGeoJson';
import extendPopulation from '../../utils/extendPopulation';

import Settings from './settings';
import Search from './search';
import Table from './table';
import TableSmall from './table-small';
import Map from './map';
import Chart from './chart';

import countriesGeo from '../../data/countries.geo.json';
import countriesISO2 from '../../data/iso2codes.json';

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      targetCountryISO2: '',
      searchValue: '',
      orderValuePeriod: DEFAULT_PERIOD,
      orderValueQuality: DEFAULT_QUALITY,
    };
    this.handleCountryChoice = this.handleCountryChoice.bind(this);
    this.handleChoiceReset = this.handleChoiceReset.bind(this);
    this.handleSettings = this.handleSettings.bind(this);
  }

  componentDidMount() {
    this.getData();
    this.getGeoLocation();
    this.getPopulationData(countriesISO2);
    this.getGlobalTimeSeriesData();
  }

  handleCountryChoice(data) {
    this.setState({ targetCountryISO2: data });
  }

  handleChoiceReset() {
    this.setState({ targetCountryISO2: '' });
  }

  handleSettings(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async getData() {
    const { countries, global, date } = await getWorldData();
    this.setState({ countries, global, date });
  }

  async getGeoLocation() {
    const data = await getGeoLocationData();
    const featuresMarkers = createGeoJson(data); // create features Markers
    const featuresCountries = { ...countriesGeo }; // create features Countries
    this.setState({ featuresCountries, featuresMarkers });
  }

  async getPopulationData(codes) {
    const data = await getPopulation(codes);
    this.setState({ countriesPopulation: data });
  }

  async getGlobalTimeSeriesData() {
    const data = await getGlobalTimeSeries();
    this.setState({ globalTimeSeries: data });
  }

  render() {
    const {
      global,
      countries,
      date,
      featuresMarkers,
      targetCountryISO2,
      searchValue,
      featuresCountries,
      orderValuePeriod,
      orderValueQuality,
      countriesPopulation,
      globalTimeSeries,
    } = this.state;
    if (!global
      || !countries
      || !date
      || !featuresMarkers
      || !featuresCountries
      || !globalTimeSeries
      || !countriesPopulation) {
      return (
        <div>Loading...</div>
      );
    }
    // countries extend ISO3, center[lat, lng], flagURL
    let copyCountries = extendFlagURL(countries, featuresMarkers);
    copyCountries = extendPopulation(copyCountries, countriesPopulation);
    // extend covid statistics (filters by iso3)
    const geoCountries = countriesExtendCovidData(featuresCountries, copyCountries);
    const geoMarkers = markersExtendCovidData(featuresMarkers, copyCountries);

    return (
      <div className="dashboard">
        <div className="row row_settings">
          <Settings handleChange={this.handleSettings} />
          <Search handleChange={this.handleSettings} />
        </div>
        <div className="row">
          <div className="table col-md-2" id="table">
            <Table
              quality={orderValueQuality}
              period={orderValuePeriod}
              param={CONFIRMED}
              global={global}
              countries={copyCountries}
              date={date}
              handleCountry={this.handleCountryChoice}
              handleReset={this.handleChoiceReset}
              searchValue={searchValue}
            />
          </div>
          <div className="map col-md-5">
            <Map
              geoCountries={geoCountries}
              geoMarkers={geoMarkers}
              targetCountryISO2={targetCountryISO2}
            />
          </div>
          <div className="second-col col-md-5">
            <div className="row tables-sm">
              <div className="table-sm col-md-6" id="table">
                <TableSmall
                  quality={orderValueQuality}
                  period={orderValuePeriod}
                  param={DEATHS}
                  global={global}
                  countries={copyCountries}
                  targetCountryISO2={targetCountryISO2}
                />
              </div>
              <div className="table-sm col-md-6" id="table">
                <TableSmall
                  quality={orderValueQuality}
                  period={orderValuePeriod}
                  param={RECOVERED}
                  global={global}
                  countries={copyCountries}
                  targetCountryISO2={targetCountryISO2}
                />
              </div>
            </div>
            <div className="chart row">
              <Chart
                global30={globalTimeSeries}
                quality={orderValueQuality}
                period={orderValuePeriod}
                param={CONFIRMED}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
